import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';
import { getAllRouteData } from '../../lib/get-all-route-data';
import { getFullPath } from '../../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { RedirectService } from '../../services/redirect.service';

const isInternalLink = (url: string) => {
  if (!url) return false;
  return url.startsWith('/');
};

const redirect = (url: string, redirectType: 'permanent' | 'temporary', redirectService: RedirectService) => {
  if (isInternalLink(url)) {
    const path = url
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter(a => a);
    const searchString = url.split('?')[1]?.split('#')[0];
    const searchParams = new URLSearchParams(searchString);
    const query = {};
    for (const [key, value] of searchParams.entries()) {
      query[key] = value;
    }
    return redirectService.redirectTo(path, { queryParams: query, redirectType });
  }

  return redirectService.externalRedirectTo(url, redirectType);
};

export const storyblokRedirectGuard: CanActivateFn = async route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const redirectService = inject(RedirectService);

  const path = getAllRouteData(route).storyblokPathOverride || getFullPath(route).join('/') || 'home';

  const story = await firstValueFrom(
    storyblokService.getStory(path, route).pipe(map(resp => (resp && resp.story) || (false as const)))
  );

  if (!story) return false;
  return redirect(storyblokService.getUrlLink(story.content.redirectTo), story.content.redirectType, redirectService);
};
